import '../applied_filter_view.js.coffee';# Added by Script 
Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.AppliedTagsNodeNameView extends Monitoring.Views.SocialContents.Filters.AppliedFilterView
  name: 'tags_node_name'
  alias: "Tag node name"
  humanize: true

  removeFilter: (value) ->
    @searchQuery.removeTagsNodeName(value)
